import { isAxiosError } from 'axios';

export function mutationErrorMessage(error: unknown): string {
  if (!isAxiosError(error))
    return 'The result could not be confirmed. Refresh the list before retrying.';
  const status = error.response?.status;
  if (status === 401) return 'Your session has expired. Please sign in again.';
  if (status === 403)
    return 'Editing is unavailable or your account does not have permission. Reload after access or editing mode changes.';
  if (status === 404)
    return 'This exclusion no longer exists. The list has been refreshed.';
  if (status === 409)
    return 'This exclusion already exists. Check the current rules before adding it again.';
  if (status === 422) {
    const payload: unknown = error.response?.data;
    if (
      payload &&
      typeof payload === 'object' &&
      'message' in payload &&
      typeof payload.message === 'string'
    ) {
      return payload.message;
    }
    return 'One or more product codes do not exist. No rules were added.';
  }
  if (status === 400) return 'Check the rule values and try again.';
  return 'The result could not be confirmed. The list is being refreshed; check it before retrying.';
}
